import { Component } from '@angular/core';
import { CommonService } from 'src/app/services/common-services/common.service';
export interface Job {
  id:number;
  title: String,
  description: String;
  experience:String;
  location :String;
  category: String;
}
@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss']
})
export class CareerComponent {
  jobList:Job[] = [];
  mainJobList:Job[] = [];
  filterCategory = [
    "All Jobs", "Sales", "Management", "Engineering"
  ]
  activeCat:string = 'All Jobs';
  constructor(private commonService: CommonService){}
  ngOnInit(){
    this.getJobs();
  }
  getJobs(){
    let apiUrl = 'assets/json/vacancy.json';
    this.commonService.getData(apiUrl).subscribe({
      next: (res:any) =>{
        this.jobList = res.data;
        this.mainJobList = [...res.data]
      }
    });
  }
  getSelectCategory(category:string){
    this.activeCat = category;
    if(category !== 'All Jobs'){
      this.jobList = this.mainJobList.filter( (item:any) => item.category === category);
    } else{
      this.jobList = this.mainJobList;
    }
    
  }
  
  getRoleClass(role: any):string {
    switch (role) {
      case 'Sales':
        return 'role-sale';  
      case 'Engineering':
        return 'role-eng';
        case 'Management':
        return 'role-mngt';
      default:
        return 'role-default';
    }
  }
}
